import React from 'react';
import './OutageDetails.css';
import {REPAIR_STATUS_URL} from '../../../constants/constants';
import {checkUrlPath} from '../../modules/CommonFunctions';

const Outagedetails = ({outageData})=>{
    const noDynamicData = outageData.resourcesummary;
    const isNooutage = noDynamicData === null;
    let outagestatus = "";
    let messageLeft = "";
    let messageRight = "";
    let locationCode = "";
    if(!isNooutage){
        const mainResponse =  noDynamicData[0].insights;
        outagestatus = mainResponse.outagestatus;
        messageLeft = mainResponse.new_header;
        messageRight = mainResponse.new_verbiage;
        locationCode = mainResponse.statecode;
    }
    
    let renderElement =  <React.Fragment>
    <div className="details-container">
    <div className="flex-1">
        <span className="headline-left">
        No outage reported
        </span>
        <p className="location">
        {locationCode}
        </p>
    </div>
    </div>
   <div className="repair-status">
       <label className="outage-label">Existing repair request?</label>
       <p className="headline-1">Check the status of an existing repair request, or update an existing  request.</p>
       <p>  
        <a target="_self" href={checkUrlPath(REPAIR_STATUS_URL)} data-track="Check repair status"  id="nooutage-link"> Check repair status  >                      
        </a>
        </p>
   </div>
    </React.Fragment>
    if(outagestatus === "CLOSED"|| outagestatus==="RESOLVED"){
        renderElement = <React.Fragment>
        <div className="details-container">
        <div className="flex-1">
            <span className="headline-left">
            {messageLeft}
            </span>
            <p className="location">
            {locationCode}
            </p>
        </div>
        <div className="flex-1">
                <span className="headline-right">
                {messageRight}
                </span>
        </div>
        </div>
       <div className="repair-status">
           <label className="outage-label">Existing repair request?</label>
           <p className="headline-1">Check the status of an existing repair request, or update an existing  request.</p>
           <p>  <a target="_self" href={checkUrlPath(REPAIR_STATUS_URL)} data-track="Check repair status"  id="nooutage-link"> Check repair status  >                      
                 </a>
              </p>
       </div>
        </React.Fragment>
    }
    if(outagestatus === 'OPEN'){
        renderElement= <React.Fragment>
        <div className="details-container">
        <div className="flex-1">
            <span className="headline-left">
            {messageLeft}
            </span>
            <p className="location">
            {locationCode}
            </p>
        </div>
        <div className="flex-1">
            <span className="headline-right">
            {messageRight}
            </span>
        </div>
        </div>
       <div >
       <p className="action-container">Manage updates</p>
       </div>
        </React.Fragment>
    }

    return (
        <div className="main-container">
            {renderElement}
        </div>
    )
}
export default Outagedetails;



// WEBPACK FOOTER //
// ./src/components/NetworkOutage/OutageDetails/OutageDetails.js